import { Helper } from "../_helpers";
import router from "../router";

const state = { all: {} };

const actions = {};

const mutations = {};

export const administrator = {
  namespaced: true,
  state,
  actions,
  mutations
};
